import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Select, Button, Input } from 'antd';
import './styles.css'

const { Option } = Select;

const FormNewPlace = ({ onSubmit, countrySelected, provinceSelected, citySelected, provincesNewPlace, onCountrySelectedNewPlace, countries, isNewCountry, isNewProvince, isEditCity, isSaving, onExit, isSaved }) => {
    
    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    }

    const onExitForm = () => {
        onExit();
    }

    const getNeighborhoods = () => {
        var neighborhoods = [];
        if(citySelected && citySelected["neighborhoods"]) {
            citySelected["neighborhoods"].forEach(neighborhood => {
                neighborhoods.push(neighborhood.name);
            });
        }
        return neighborhoods;
    }

    const getHitos = () => {
        var hitos = [];
        if(citySelected && citySelected["hitos"]) {
            citySelected["hitos"].forEach(hito => {
                hitos.push(hito.name);
            });
        }
        return hitos;
    }

    const onCountrySelected = value => {
        form.setFieldsValue({
            field_province: undefined,
            field_city: undefined,
            field_postal_code: undefined,
            field_hitos: undefined,
            field_neighborhoods: undefined
        })
        onCountrySelectedNewPlace(value)
    }

    const onProvinceSelected = value => {
        form.setFieldsValue({
            field_city: undefined,
            field_postal_code: undefined,
            field_hitos: undefined,
            field_neighborhoods: undefined
        })
    } 

    return (
        <Grid>
            <Form onFinish={onSubmit} form={form}
            initialValues={{
                field_country: countrySelected,
                field_province: provinceSelected,
                field_city: (isEditCity && citySelected && citySelected.name) ? citySelected.name : null,
                field_postal_code: (isEditCity && citySelected && citySelected.postalCode) ? citySelected.postalCode : null,
                field_hitos: getHitos(),
                field_neighborhoods: getNeighborhoods()
            }}>
                <Row center="xs">
                    <Col xs={12} sm={6} md={6}>
                        {
                            isNewCountry || isEditCity ?
                                isEditCity ?
                                    <Form.Item name="field_country" rules={[{ required: false, message: 'Por favor, seleccione un país' }]}>
                                        <Select placeholder="País" disabled={true}>
                                        </Select>
                                    </Form.Item>
                                    :
                                    <Form.Item name="field_country" rules={[{ required: true, message: 'Por favor, complete el nombre del país', }]}>
                                        <Input placeholder="País"/>
                                    </Form.Item>
                                :
                                <Form.Item name="field_country" rules={[{ required: true, message: 'Por favor, seleccione un país' }]}>
                                    <Select placeholder="País" onSelect={onCountrySelected}>
                                        {
                                            countries && countries.map(country => <Option key={country} value={country}>{country}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                        }
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                        {
                            isNewProvince || isNewCountry || isEditCity ?
                                isEditCity ?
                                    <Form.Item name="field_province" rules={[{ required: false, message: 'Por favor, seleccione una provincia' }]}>
                                        <Select placeholder="Provincia" disabled={true}>
                                        </Select>
                                    </Form.Item>
                                    :
                                    <Form.Item name="field_province" rules={[{ required: true, message: 'Por favor, complete el nombre de la provincia', }]}>
                                        <Input placeholder="Provincia"/>
                                    </Form.Item>
                                :
                                <Form.Item name="field_province" rules={[{ required: true, message: 'Por favor, seleccione una provincia' }]}>
                                    <Select placeholder="Provincia" onSelect={onProvinceSelected}>
                                        {
                                            provincesNewPlace && provincesNewPlace.map(province => <Option key={province} value={province}>{province}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                        }
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="field_city" rules={[{ required: true, message: 'Por favor, complete el nombre de la ciudad', }]}>
                            <Input placeholder="Ciudad"/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="field_postal_code" rules={[{ required: true, message: 'Por favor, complete el código postal de la ciudad', }]}>
                            <Input placeholder="Código Postal"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="field_hitos" rules={[{ required: false }]}>
                            <Select
                                className="selectCont"
                                mode="tags"
                                size="default"
                                placeholder="Hitos">
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                        <Form.Item name="field_neighborhoods" rules={[{ required: false }]}>
                            <Select
                            className="selectCont"
                            mode="tags"
                            size="default"
                            placeholder="Barrios">
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={1} sm={2} md={4}></Col>
                    <Col xs={5} sm={4} md={2}>
                        <Form.Item>
                            {
                                isSaving ?
                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                        Guardando
                                    </Button>
                                    :
                                    <Button type="primary" htmlType="submit">
                                        Guardar
                                    </Button>
                            }
                        </Form.Item>
                    </Col>
                    <Col xs={5} sm={4} md={2}>
                        <Form.Item>
                            {
                                <Button disabled={isSaving} onClick={onExitForm}>
                                    Cancelar
                                </Button>
                            }
                        </Form.Item>
                    </Col>
                    <Col xs={1} sm={2} md={4}></Col>
                </Row>
                {
                    isSaved && onReset()
                }
            </Form>
        </Grid>
    );
};

FormNewPlace.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default FormNewPlace;